import script from "./Trapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trapper.vue?vue&type=script&setup=true&lang=ts"

import "./Trapper.vue?vue&type=style&index=0&id=3af97091&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af97091"]])

export default __exports__